import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';

import { SafeResourceUrlPipe } from './safe-resource-url.pipe';

@Component({
    selector: 'app-demo',
    standalone: true,
    imports: [CommonModule, SafeResourceUrlPipe],
    templateUrl: './demo.component.html',
    styleUrl: './demo.component.scss'
})
export class DemoComponent {
    @ViewChild('demoFrame') demoFrame!: ElementRef<HTMLIFrameElement>;
    demoUrl = '/assets/demo/index.html';
}
